/**
 * Credit Holds (P45 U67; FSD 5.2.2 Release Credit Hold), spread into `SALES_ROUTES`.
 *
 * Named for the permission the server guards the queue's read with (`sales.order.read`);
 * releasing is checked per row inside the screen (`sales.credit_hold.release`). Nav id
 * `sales-credit-holds` (section s-5.2.2, added by INT). Literal path for the deep-link parser.
 */

import type { RouteRecordRaw } from 'vue-router'

import { SALES_PERMISSIONS } from '@/modules/sales/permissions'

export const CREDIT_HOLD_ROUTES: RouteRecordRaw[] = [
  {
    path: '/sales/credit-holds',
    name: 'sales-credit-holds',
    component: () => import('@/modules/sales/credit-holds/CreditHoldsView.vue'),
    meta: { titleKey: 'sales.u67.creditHolds.routeTitle', permission: SALES_PERMISSIONS.orderRead },
  },
]
